import _ from "lodash";

export const managedQueryParameters = {
  created() {
    this.initialQueryParameters = this.queryParameters();
  },

  data() {
    return {
      initialQueryParameters: null,
    };
  },

  methods: {
    objectToQueryString(object) {
      if (typeof object !== "object") return "";

      return Object.keys(object)
        .map((key) => {
          return (
            encodeURIComponent(key) + "=" + encodeURIComponent(object[key])
          );
        })
        .join("&");
    },

    sanitizeParameters(parameters) {
      const original = JSON.parse(JSON.stringify(parameters));
      let sanitized = {};

      Object.keys(original).forEach((key) => {
        // Empty object or array, and not a number or true
        if (
          _.isEmpty(original[key]) &&
          !_.isNumber(original[key]) &&
          original[key] !== true
        )
          return;

        sanitized[key] = original[key];
        if (typeof sanitized[key] === "string") {
          sanitized[key] = sanitized[key].replace(/[^a-zA-Z0-9_\-\s]/g, "");
        }
      });

      return sanitized;
    },
    clearQueryParameters() {
      const path = this.$route.path;
      this.$router.replace({ path, query: {} });
    },
    updateQueryParameters(changes, historyOnly = true) {
      const path = this.$route.path;
      const query = this.sanitizeParameters({
        ...this.queryParameters(),
        ...changes,
      });

      if (historyOnly) {
        window.history.pushState(
          {},
          null,
          `${path}?${this.objectToQueryString(query)}`
        );
      } else {
        this.$router
          .replace(`${path}?${this.objectToQueryString(query)}`)
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      }
    },

    queryParameters() {
      let queryString = decodeURI(window.location.search) || "";
      queryString = queryString.substring(1);
      let keyValPairs = [];
      let queryParameters = {};

      if (queryString.length) {
        keyValPairs = queryString.split("&");
        keyValPairs.forEach((pair) => {
          let [key, value] = pair.split("=");
          value = decodeURIComponent(value);
          if (key && !queryParameters[key]) {
            queryParameters[key] = [];
          }
          if (key && queryParameters[key]) {
            if (value.includes(",")) {
              queryParameters[key] = _.union(
                queryParameters[key],
                value.split(",")
              );
            } else {
              queryParameters[key] = _.union(queryParameters[key], [
                decodeURIComponent(value),
              ]);
            }
          }
        });
      }

      return queryParameters;
    },
  },
};

export default {
  managedQueryParameters,
};
